import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { heightPercentageToDP } from 'utils/responsiveness';

import { ImageSize } from 'components/NagraImage/types';

const styles = StyleSheet.create({
    iconContainer: {
        width: ImageSize.PROFILE_IMAGE.width,
        height: ImageSize.PROFILE_IMAGE.width,
        borderRadius: ImageSize.PROFILE_IMAGE.width,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: heightPercentageToDP(4),
    },
});

export default styles;
